export const filterProperties = (
  obj: { [key: string]: any },
  properties: string[],
) => {
  const filteredObj = {};
  properties.forEach((property: string) => {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(property)) {
      filteredObj[property] = obj[property];
    }
  });

  return filteredObj;
};
